<template>
  <div class="PageContentWrapper">
    <div class="ViewContainer">
      <div class="MyCourses">
        <span class="MCTitle">{{
          $t("pages.profile.main.courses.title")
        }}</span>

        <table class="course-table">
          <thead>
            <tr>
              <th>{{ $t("pages.profile.main.courses.table.name") }}</th>
              <th class="HideOnMobile">
                {{ $t("pages.profile.main.courses.table.status") }}
              </th>
              <th class="HideOnMobile">
                {{ $t("pages.profile.main.courses.table.start") }}
              </th>
              <th>{{ $t("pages.profile.main.courses.table.actions") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(course, cindx) in this.courses"
              :key="`course-${cindx}-${course.id}-${course.name}`"
            >
              <td class="CourseName">
                <span :lang="curLang">{{ course.name }}</span>
              </td>

              <td class="HideOnMobile">
                <div
                  :class="{
                    msg: true,
                    wait:
                      statuses[
                        course.Project_Job_Statuses[
                          course.Project_Job_Statuses.length - 1
                        ].status
                      ] === 'waiting',
                    warn:
                      statuses[
                        course.Project_Job_Statuses[
                          course.Project_Job_Statuses.length - 1
                        ].status
                      ] === 'fail',
                    active:
                      statuses[
                        course.Project_Job_Statuses[
                          course.Project_Job_Statuses.length - 1
                        ].status
                      ] === 'active',
                  }"
                >
                  <span>
                    {{
                      $t(
                        coursesStatusesText[
                          course.Project_Job_Statuses[
                            course.Project_Job_Statuses.length - 1
                          ].status
                        ]
                      )
                    }}
                  </span>

                  <img
                    v-if="
                      statuses[
                        course.Project_Job_Statuses[
                          course.Project_Job_Statuses.length - 1
                        ].status
                      ] === 'fail'
                    "
                    src="./../../assets/img/ReDesign/interface_icons/moderation_fail_16px.svg"
                    alt=""
                  />

                  <div class="DeclineMSG">
                    <span>{{
                      course.Project_Job_Statuses[
                        course.Project_Job_Statuses.length - 1
                      ].comment
                    }}</span>
                  </div>
                </div>
              </td>

              <td class="HideOnMobile">
                <a href="#" class="start-date">02.09.2025</a>
              </td>

              <td class="actions">
                <router-link
                  class="actionBtn"
                  :to="`/org/course-add?courseID=${course.id}`"
                >
                  <img
                    src="./../../assets/img/ReDesign/interface_icons/Change.svg"
                    alt=""
                  />
                </router-link>

                <div 
                  class="actionBtn"
                  @click="switchIsVisible(course)"
                >
                  <img
                    v-show="course.isVisible"
                    src="./../../assets/img/ReDesign/interface_icons/View.svg"
                    alt=""
                  />
                  <img
                    v-show="!course.isVisible"
                    src="./../../assets/img/ReDesign/interface_icons/ViewNo.svg"
                    alt=""
                  />
                </div>

                <div
                  class="actionBtn"
                  @click="removeJobFromList(course.id)"
                >
                  <img
                    src="./../../assets/img/ReDesign/interface_icons/Delete.svg"
                    alt=""
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findByAuthorId } from "@/api/n_project.js";
import { removeJob, updateJobIsVisible } from "@/api/job.js";

export default {
  name: "CoursesList",

  components: {
  },

  data() {
    return {
      companyProject: null,
      courses: [],

      coursesStatusesText: {
        Ожидает: "tables.statuses.awaiting",
        Одобрено: "tables.statuses.approved",
        Отклонено: "tables.statuses.rejected",
      },
      statuses: {
        Ожидает: "waiting",
        Одобрено: "active",
        Отклонено: "fail",
      },
    };
  },

  async created() {
    await this.getCourses();
  },

  methods: {
    async getCourses() {
      try {
        let getCompanyCoursesRaw = await findByAuthorId(this.user.id);
        let companyWithCourses = getCompanyCoursesRaw.data;

        this.companyProject = companyWithCourses[0];
        this.courses = companyWithCourses[0].Jobs;

        this.setProfileStatus();
      } catch (e) {}
    },

    setProfileStatus() {
      if (
        this.companyProject?.Project_Job_Statuses == null ||
        this.companyProject.Project_Job_Statuses.length === 0
      ) {
        this.isloading = false;
        return;
      }

      const maxIdObject = this.companyProject.Project_Job_Statuses.reduce(
        (max, obj) => (obj.id > max.id ? obj : max),
        this.companyProject.Project_Job_Statuses[0]
      );

      this.moderation = {
        state: this.statuses[maxIdObject.status],
        msg: maxIdObject.comment,
      };

      this.isloading = false;
    },

    switchIsVisible(course) {
      course.isVisible = !course.isVisible;
      updateJobIsVisible(course.id, { isVisible: course.isVisible });
    },

    async removeJobFromList(jobid) {
      await removeJob([jobid]);
      await this.getCourses();
    },
  },

  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),
  },
};
</script>

<style scoped>
.PageContentWrapper {
  position: relative;
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  gap: 36px;

  width: 100%;

  height: 100%;

  padding-top: 15px;

  overflow: visible;
}

.ViewContainer {
  position: relative;

  margin: 0% auto;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;

  overflow: visible;
}

.MyCourses {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.MCTitle {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: Involve;
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}

.course-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 16px 32px -4px #0c0c0d0a;
}

.course-table th {
  font-family: "Involve";
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
  word-break: break-word;
}

.course-table th {
  padding: 18px 24px;
  text-align: left;
  font-size: 14px;
}
.course-table td {
  padding: 4px 24px;
  text-align: left;
  font-size: 14px;
}

.course-table thead {
  background: #f8f8f8;
  font-weight: bold;
  border-bottom: 1px solid #e0e0e0;
}
.course-table td {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
}

.CourseName {
  max-width: 300px;
}

.CourseName > span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
}

.msg > * {
  margin: auto 0%;
}
.msg {
  position: relative;
  display: flex;

  padding: 4px 8px;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  border-radius: 4px;
}
.msg.wait {
  color: #876500;
  background-color: #fff0c3;
}
.msg.warn {
  color: #dc3545;
  background-color: #ffe8e9;
}
.msg.active {
  color: #28a745;
  background-color: #e4ffea;
}

.DeclineMSG {
  position: absolute;
  display: none;

  bottom: -4px;
  left: 0;

  padding: 4px 8px;

  width: fit-content;
  max-width: 280px;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #dc3545;

  background-color: #ffe8e9;

  border-radius: 4px;

  transition: 0.3s;
  opacity: 0;

  transform: translateY(100%);
  z-index: 2;
}

.msg.warn:hover > .DeclineMSG {
  display: flex;
  opacity: 1;
}

.start-date {
  color: #666666;
  text-decoration: none;
  border-bottom: 1px solid #ccc;
}

.actions {
  display: flex;
  gap: 10px;
}
.actions button {
  width: 18px;
  height: 18px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.actions .actionBtn {
  position: relative;
  display: flex;

  cursor: pointer;

  width: 40px;
  height: 40px;
}
.actions .actionBtn > img {
  position: relative;
  width: 16px;
  margin: auto;
}
</style>

<style scoped>
@media (max-width: 768px) {
  .course-table thead > tr,
  .course-table tbody > tr {
    grid-template-columns: minmax(0px, 1fr) 132px;
  }

  .HideOnMobile {
    display: none;
  }

  .course-table .actions {
    gap: 4px;
    padding: 4px 0px 4px 4px;
  }

  .course-table .CourseName {
    padding: 4px 0px 4px 16px;
  }

  .course-table th {
    padding: 18px 16px;
  }

  .CourseName {
    overflow-wrap: break-word;
  }

  .course-table {
    overflow: hidden;
  }
}
</style>